import React from 'react';
import Navbar from '../components/Navbar';

export default function ContattiPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="pt-20 p-6 max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Contatti</h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Informazioni Generali */}
          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Informazioni generali</h2>
            <div className="space-y-4">
              <div>
                <p className="text-sm text-gray-500 mb-1">Email</p>
                <a href="mailto:info@acbase.org" className="text-blue-600 hover:underline">
                  info@acbase.org
                </a>
              </div>
            </div>
          </div>

          {/* Sede */}
          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Sede</h2>
            <p className="text-gray-700">
              Via del Plebiscito, 112<br />
              00186 Roma (RM)<br />
              Italia
            </p>
          </div>
        </div>
      </div>

    </div>
  );
}
